import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReferralForm from "@src/containers/PersonalLoan/containers/ReferralForm/referralForm";
import { Wrapper } from "./declinedReferral.styles";
import CheckBox from "@components/checkBox/index";
import { useSelector } from "react-redux";
import { themes } from "@src/theme/config";
import environmentSettings from "@src/constants/environmentSettings";

const getFormValue = ({ loanFormResponse, initialValue }) => {
  return loanFormResponse != null
    ? { ...loanFormResponse.value }
    : initialValue;
};

export const DeclinedReferral = ({ referralConsent }) => {
  const themeName = useSelector(state => state.StartUp.theme.themeName);
  const loanFormState = useSelector((state) => state.loanForm);
  const formValue = getFormValue(loanFormState);

  const { companyName } = environmentSettings;

  const [hasReferralConsent, setReferralConsent] = useState(referralConsent);

  const handleCheckBox = () => {
    setReferralConsent(!hasReferralConsent);
  };

  useEffect(() => {
    if (referralConsent === true) {
      setReferralConsent(true);
    }
  }, [setReferralConsent, referralConsent]);

  return (
    <Wrapper checked={hasReferralConsent}>
      {themeName !== themes.fgfParent.loanOptions.themeName && (
        <div className="consent-wrapper">
          <h3>If you wish,</h3>
          <p>
            We can refer your details to another lender who may be able to help
            you.
          </p>
          <label>
            <CheckBox
              onChange={handleCheckBox}
              checked={hasReferralConsent}
              name="referralConsent"
            >
              <strong>Referral Consent</strong> : Given we are unable to offer a
              loan today, we may be able to refer you to other credit providers
              and alternative service providers as described in our Privacy
              Policies, who may be able to offer you an alternative finance option
              (including a line of credit, unsecured personal loan or vehicle
              loan). Do you give us approval to do this and agree to sending your
              contact details, name and financial information to these providers?
            </CheckBox>
          </label>
        </div>
      )}
      {(themeName !== themes.fgfParent.loanOptions.themeName) ? (
        <div className="form-wrapper">
          <ReferralForm values={formValue} />
        </div>
      ) : (
        ""
      )}

      <div className="keep-in-touch">
        <p className="keep-in-touch-content">
          We'll also keep in touch with further tips on how to improve your
          credit chances in the hope we may be able to assist you in the future.
        </p>
        <p className="keep-in-touch-thanks">Thank you for considering us.</p>
        <h3 className="keep-in-touch-fgf">{companyName}</h3>
      </div>
    </Wrapper>
  );
};

DeclinedReferral.propTypes = {
  referralConsent: PropTypes.bool,
}